import PropTypes from "prop-types";
import styles from "./style.module.scss";
const Divider = ({ title, onClick }) => {
  return (
    <div className={styles.dividerwrapper}>
      <hr className={styles.line} />
      <h4 className={styles.dividertext}>
        <span className={styles.mask}>OR</span>
      </h4>
    </div>
  );
};



export default Divider;
